import { buildQuery } from 'ra-data-graphql-simple';
import Query from './Query';

export const customQuery = (introspection) => (fetchType, resource, params) => {
  const builtQuery = buildQuery(introspection)(fetchType, resource, params);
  switch (resource) {
    case 'Merchant': {
      const queries = Query.Merchant;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
          };
        }
        case 'CREATE': {
          return {
            ...builtQuery,
            query: queries.CREATE,
          };
        }
        case 'DELETE_ONE': {
          return {
            ...builtQuery,
            query: queries.DELETE_ONE,
          };
        }
        case 'Bill': {
          const queries = Query.Bill;
          switch (fetchType) {
            case 'GET_LIST': {
              return {
                ...builtQuery,
                query: queries.GET_LIST
              }
            }
            case 'GET_ONE': {
              return {
                ...builtQuery,
                query: queries.GET_ONE
              }
            }
            case 'UPDATE': {
              return {
                ...builtQuery,
                query: queries.UPDATE
              }
            }
            case 'CREATE': {
              return {
                ...builtQuery,
                query: queries.CREATE
              }
            }
            case 'DELETE_ONE': {
              return {
                ...builtQuery,
                query: queries.DELETE_ONE
              }
            }
            default: {
              break;
            }
          }
          break;
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'SubMerchant': {
      const queries = Query.SubMerchant;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
          };
        }
        case 'CREATE': {
          return {
            ...builtQuery,
            query: queries.CREATE,
          };
        }
        case 'DELETE_ONE': {
          return {
            ...builtQuery,
            query: queries.DELETE_ONE,
          };
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'BackUser': {
      const queries = Query.BackUser;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
          };
        }
        case 'CREATE': {
          return {
            ...builtQuery,
            query: queries.CREATE,
          };
        }
        case 'DELETE_ONE': {
          return {
            ...builtQuery,
            query: queries.DELETE_ONE,
          };
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'Employee': {
      const queries = Query.Employee;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
          };
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'Terminal': {
      const queries = Query.Terminal;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
          };
        }
        case 'CREATE': {
          return {
            ...builtQuery,
            query: queries.CREATE,
          };
        }
        case 'DELETE_ONE': {
          return {
            ...builtQuery,
            query: queries.DELETE_ONE,
          };
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'Category': {
      const queries = Query.Category;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
          };
        }
        case 'GET_ONE': {
          return {
            ...builtQuery,
            query: queries.GET_ONE,
          };
        }
        case 'CREATE': {
          return {
            ...builtQuery,
            query: queries.CREATE,
            variables: {
              ...params.data,
              parentID: 0,
            },
          };
        }
        case 'UPDATE': {
          return {
            ...builtQuery,
            query: queries.UPDATE,
            variables: {
              ...params.data,
              parentID: 0,
            },
          };
        }
        default: {
          break;
        }
      }
      break;
    }
    case 'Item': {
      const queries = Query.Item;
      switch (fetchType) {
        case 'GET_LIST': {
          return {
            ...builtQuery,
            query: queries.GET_LIST,
            variables: {
              filter: params.filter,
            },
          };
        }

        default: {
          break;
        }
      }
      break;
    }
    default: {
      break;
    }
  }
  return builtQuery;
};
